export default "__VITE_ASSET__0d0f1356__"